// extracted by mini-css-extract-plugin
export default {"nav__sushi":"CategorySushi_nav__sushi__poHID","active__nav":"CategorySushi_active__nav__5dhrf"};